import { lazyWithPreload } from '../../navigation';

export const StyleguidesScreen = lazyWithPreload(() =>
    import('./StyleguidesScreen').then((m) => ({ default: m.StyleguidesScreen }))
);
